import styled, { css } from 'styled-components';

import Alert from '@bitcoin-portal/verse-web-components/dist/Alert';
import Button from '@bitcoin-portal/verse-web-components/dist/Button';
import ChevronRight from '@bitcoin-portal/verse-web-components/dist/Icons/ChevronRight';
import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column nowrap;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.unit * 3}px;
  padding: 0px ${({ theme }) => theme.spacing.unit * 3}px;
`;

export const ViewWrapper = styled.div<{
  noHorizontalPadding?: boolean;
}>`
  ${({ theme, noHorizontalPadding = false }) => css`
    padding: ${theme.spacing.unit * 3}px
      ${noHorizontalPadding ? '0px' : `${theme.spacing.unit * 3}px`};
    box-sizing: border-box;

    ${media.sm`
            padding: ${theme.spacing.unit * 6}px
                 ${noHorizontalPadding ? '0px' : `${theme.spacing.unit * 5}px`}
                 ${theme.spacing.unit * 5}px;
            width: 600px;
        `}
  `}
`;

export const StyledChevron = styled(ChevronRight)`
  transform: rotateZ(180deg);
  color: ${colors.verseBlue};
  cursor: pointer;
  position: absolute;
  top: 48px;
  left: 40px;
`;

export const SelectCurrencyContentWrapper = styled.div<{
  selected: boolean;
}>`
  ${({ theme, selected }) => css`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;

    & > * + * {
      margin-left: ${theme.spacing.unit * 0.5}px;
    }

    & > div:last-child {
      display: ${selected ? 'none' : 'flex'};
      flex-direction: column;
      align-items: flex-start;
      & > span:first-child {
        color: ${theme.palette.text.default};
        font-weight: 800;
      }
      & > span:last-child {
        font-size: 13px;
        font-weight: 600;
        color: ${theme.palette.text.secondary};
      }

      ${media.sm`
                display: flex;
            `}
    }
  `}
`;

export const EthAlert = styled(Alert)`
  display: grid;
  grid-template-areas: 'icon text' 'button button';
  grid-row-gap: ${({ theme }) => theme.spacing.unit * 2}px;
  flex-flow: row wrap;
  border: 1px solid ${colors.red75} !important;
  margin-top: ${({ theme }) => theme.spacing.unit * 3}px;

  & > svg {
    grid-area: icon;
  }

  ${media.sm`
        grid-template-areas: 'icon text button';
    `}
`;

export const AlertButton = styled(Button)`
  background: ${colors.white};
  white-space: nowrap;
  padding: 5px 12px;
  max-height: 24px;
  align-self: flex-start;
  grid-area: button;
  width: 100%;
  &:hover {
    background: ${colors.shade100};
  }
  > a {
    color: ${colors.red100};
  }

  ${media.sm`
        width: fit-content;
    `}
`;

// slider
export const SliderWrapper = styled.div`
  box-sizing: border-box;
  border: 1px solid ${colors.shade50};
  border-radius: 12px;
  padding: 20px;
  background-color: ${colors.verseNavBlue};
  margin-bottom: 24px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  & > :first-child {
    width: 100%;
    margin-right: 20px;
    cursor: pointer;
  }
`;

export const RemoveLiquidityWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.unit * 3}px;

    ${media.sm`
            padding: ${theme.spacing.unit * 4}px ${theme.spacing.unit * 6}px;
        `}
  `}
`;

export const NoLiquidityWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.unit * 3}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1.3;
    border-top: 1px solid ${colors.shade30};
    & > div {
      font-weight: 500;
      color: ${colors.shade80};
      margin-bottom: ${theme.spacing.unit * 2}px;
    }
    & > a > div {
      padding: 0px ${theme.spacing.unit * 2}px;
    }

    ${media.sm`
            padding: ${theme.spacing.unit * 4}px ${theme.spacing.unit * 6}px;
            & > div {
                font-size: 14px;
            }
        `}
  `}
`;
